import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import * as store from 'store';

import TestSelectionComponent from './Component';

class TestSelectionContainer extends React.PureComponent {
  get options () {
    const {
      primaryParameterType,
      secondaryParameterSelected
    } = this.props;

    if (primaryParameterType === 'numerical' && secondaryParameterSelected) {
      return [
        { value: 'slope', label: 'Slope', text: 'Slope' },
        { value: 'correlation', label: 'Correlation', text: 'Correlation' }
      ];
    }

    switch (this.props.primaryParameterType) {
      case 'numerical':
        return [
          { value: 'mean', label: 'Mean', text: 'Mean' },
          { value: 'median', label: 'Median', text: 'Median' },
          { value: 'stdev', label: 'Standard Deviation', text: 'Standard Deviation' }
        ];
      case 'categorical':
        return [
          { value: 'proportion', label: 'Proportion', text: 'Proportion' },
          { value: 'count', label: 'Count', text: 'Count' }
        ];
      default:
        return [];
    }
  }

  render () {
    const { primaryParameterType, secondaryParameterSelected, ...props } = this.props // eslint-disable-line

    return (
      <TestSelectionComponent
        options={this.options}
        value={this.value}
        {...props}
      />
    );
  }
}

TestSelectionContainer.propTypes = {
  primaryParameterType: PropTypes.string.isRequired,
  secondaryParameterSelected: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
  primaryParameterType: store.form.bootstrapCIs.getPrimaryParameterType(state),
  secondaryParameterSelected: store.form.bootstrapCIs.isSecondaryParameterSelected(state)
});

export default connect(mapStateToProps)(TestSelectionContainer);
